import { Injectable, EventEmitter, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError, retry } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { stringify } from 'querystring';
import { Router } from '@angular/router';
import { BrowserStack } from 'protractor/built/driverProviders';
//import { resolve } from '@angular/router/';
import { LoginService } from '../login.service';

/***************************************************************************************************
 * TODO
 * - Gray out buttons for photo and text items until a photo is selected or text entered.
 * - Create Database
 * - Create Admin Interface for Database
 * - Create API for Database
 * - Hook to API
 * - Upload completed quests -- including photos
 * - Leaderboard
 * - Clean up HTML (Seciton title spacing)
 * - CSS style from server -- BOTTOM OF LIST
 * - Support e-mail from server
 * - For Text and Photo quests, disable complete button until info is entered
 * 
 * ---- DO THE FOLLOWING IN LOADING ----
 * - Error if team name does not exist
 * 
 * - In session Storage:
 *   - QuestItems
 *   - TeamInfo
 *     - Team Name
 *     - Team Code
 *   - EventInfo
 *     - CSS
 *     - Support e-mail
 *     - Event Name
 *     - Event ID
 */



@Injectable({
    providedIn: 'root'
})
export class QuestItemService {
    @Output() scoreChanged = new EventEmitter<string>();
    @Output() itemsLoaded = new EventEmitter();

    questItems: QuestItems[];
    /*
    [
        {
            "id": 0,
            "title":"Section 1 Title",
            "quests":[  {"id":0,"title":"Title1","description":"This is a description of the quest item.","points":500,"pts-awarded":500, "type": "basic", "complete": true},
                        {"id":1,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0, "type": "text"},
                        {"id":2,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0, "type": "photo"},
                        {"id":3,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0, "type": "basic"},
                        {"id":4,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0, "type": "text"}]
        },
        {
            "id": 8,
            "title":"Section 2 Title",
            "quests":[  {"id":20,"title":"Title2","description":"This is a description of the quest item.","points":500,"pts-awarded":0},
                        {"id":21,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0},
                        {"id":22,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0},
                        {"id":23,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0},
                        {"id":24,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0}]
        },
        {
            "id": 39,
            "title":"Section 3 Title",
            "quests":[  {"id":40,"title":"Title3","description":"This is a description of the quest item.","points":500,"pts-awarded":0,"0":{"pts-awarded":500}},
                        {"id":41,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0,"0":{"pts-awarded":500}},
                        {"id":42,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0,"0":{"pts-awarded":500}},
                        {"id":43,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0,"0":{"pts-awarded":500}},
                        {"id":44,"title":"Title","description":"This is a description of the quest item.","points":500,"pts-awarded":0,"0":{"pts-awarded":500}}]
        }
    ];
    */

    possibleScore: number;
    currentScore: number;

    constructor( private http: HttpClient, 
                    private router: Router, 
                    private loginService: LoginService ) {
        var storedItems: string;
        storedItems = sessionStorage.getItem("questItems");
        console.log("QuestItemService.constructor");
        console.log(storedItems);
        this.questItems = JSON.parse(storedItems);
        this.possibleScore = 0;
        this.currentScore = 0;
        console.log("this.questItems:");
        console.log(this.questItems);

/*        this.initialize();

        console.log(this.questItems);
*/
        //if (storedItems == null) {
            this.updatePossibleScore();
            this.updateCurrentScore();
        //}
        
   }

    getQuestItemsFromServer(eventId: number, teamId: number) {
         
        this.http.get("http://herenow.live/service.php?action=questList&eid=" + eventId + "&tid=" + teamId).subscribe((responseBody) => {
            this.questItems = <QuestItems[]>responseBody;
            console.log("QuestItemService.getQuestItemsFromServer()");
            console.log(responseBody);
            console.log("this.questItems:");
            console.log(this.questItems);

            this.saveQuestItems();

            this.updatePossibleScore();
            this.updateCurrentScore();
            //var score: String;
            //score = this.currentScore + "/" + this.possibleScore;
            this.router.navigate(['/quest']);
        });
    }

    private getItemById(id: number) {
        var i: number;
        var j: number;

        for (i = 0; i < this.questItems.length; i++) {
            for (j = 0; j < this.questItems[i]["quests"].length; j++) {
                if (this.questItems[i]["quests"][j].id == id) {
                    return this.questItems[i]["quests"][j];
                }
            }
        }

        console.log("quest-item.service.getItemById(): Unable to find item with id " + id);
        return null;
    }

    private updateScoreComponent() {
        var newScore: string;

        newScore = this.getScoreString();
        console.log("QuestItemService.updateScoreComponent: " + newScore);
        this.scoreChanged.emit(newScore);
    }

    private updatePossibleScore() {
        var i: number;
        var j: number;
        var score: number = 0;

        if (this.questItems == null) {
            return;
        }

        for(i = 0; i < this.questItems.length; i++) {
            if(typeof this.questItems[i]["quests"] !== 'undefined') {
                for(j = 0; j < this.questItems[i]["quests"].length; j++) {
                    score += this.questItems[i]["quests"][j]["points"];
                }
            }
        }

        this.possibleScore = score;
        console.log("QuestItemService.updatePossibleScore: " + this.possibleScore);
        this.updateScoreComponent();
    }

    private updateCurrentScore() {
        var i: number;
        var j: number;
        var score: number = 0;

        if (this.questItems == null) {
            return;
        }

        for(i = 0; i < this.questItems.length; i++) {
            if(typeof this.questItems[i]["quests"] !== 'undefined') {
                for(j = 0; j < this.questItems[i]["quests"].length; j++) {
                    score += this.questItems[i]["quests"][j]["pts-awarded"];
                }
            }
        }

        this.currentScore = score;
        console.log("QuestItemService.updateCurrentScore: " + this.currentScore);
        this.updateScoreComponent();
    }

    private saveQuestItems() {
        console.log("QuestItemService.saveQuestItems()");

        var itemStorage: string;
        itemStorage = JSON.stringify(this.questItems);
        console.log(itemStorage);
        sessionStorage.questItems = itemStorage;    
    }
/*
    initialize() {
        console.log("QuestItemService.initialize()")
        this.getQuestItemsFromServer();

        var response;
        var qItems: questItems[];
        
        if (this.questItems == null) {
            response = this.getQuestItemsFromServer();

            var d = response.data;
            console.log("data: ", d );

            
                .subscribe((data: questItems[]) => qItems = { ...data });
            
            this.questItems = this.getQuestItemsFromServer()
                .subscribe((data: Object) => response = data);
  
            var str;
            str = JSON.stringify(response);
            console.log("response: ", response);
            console.log("qItems: ", qItems);
            
        }
        
        

    }
*/
    get(sectionId: number) {
        console.log("QuestItemService:");
        console.log(sectionId);

        var i: number;
        for(i = 0; i < this.questItems.length; i++) {
            if (this.questItems[i]['id'] == sectionId) {
                console.log(this.questItems[i]);
                return this.questItems[i];
            }
        }

        return null;   
    }

    getSectionIds() {
        console.log("getSectionIds");
        var sectionIds = new Array();
        console.log(this.questItems);

        var i: number;

        if (this.questItems == null) {
            return;
        }

        for(i = 0; i < this.questItems.length; i++) {
            sectionIds.push(this.questItems[i]['id']);
        }

        console.log(sectionIds);

        return sectionIds;
    }

    getPossibleScore() {
        return this.possibleScore;
    }

    getCurrentScore() {
        return this.currentScore;
    }

    setFileToUpload(id: number, file: File) {
        var i: number;
        var j: number;

        for(i = 0; i < this.questItems.length; i++) {
            if(typeof this.questItems[i]["quests"] !== 'undefined') {
                for(j = 0; j < this.questItems[i]["quests"].length; j++) {
                    if (this.questItems[i]["quests"][j].id == id) {
                        this.questItems[i]['quests'][j]['fileToUpload'] = file;
                        return;
                    }
                }
            }
        }
    }

    getFileToUpload(id) {
        var i: number;
        var j: number;

        for(i = 0; i < this.questItems.length; i++) {
            if(typeof this.questItems[i]["quests"] !== 'undefined') {
                for(j = 0; j < this.questItems[i]["quests"].length; j++) {
                    if (this.questItems[i]["quests"][j].id == id) {
                        if (typeof this.questItems[i]['quests'][j]['fileToUpload'] === 'undefined') 
                            return null;
                        else
                            return this.questItems[i]['quests'][j]['fileToUpload'];
                    }
                }
            }
        }    

        return null;
    }

    postQuestItem(formData: FormData) {
        console.log("QuestItemService.postQuestItem()");
        
        const endPoint = 'http://herenow.live/service.php';

        return this.http
            .post(endPoint, formData).subscribe (
                (res) => console.log(res),
                (err) => console.log(err)
            );
    }

    handleError(e) {
        console.log("QuestItemService.handleError");
        console.log(e);
    }

    completeQuestItem(qiForm) {
        var item;

        console.log("QuestItemService.completeQuestItem");
        console.log(qiForm);
        
        item = this.getItemById(qiForm.id);

        console.log(item);

        item["pts-awarded"] = item["points"];
        item["complete"] = true;

        this.updateCurrentScore();

        console.log(item);
        console.log("Current Score: " + this.currentScore);

        this.saveQuestItems();
        
        // ----
        const formData: FormData = new FormData();
           
        formData.append('action', 'complete');
        formData.append('questId', qiForm.id);
        formData.append('teamId', this.loginService.getTeamId().toString());
        formData.append('eventId', this.loginService.getEventId().toString());
        formData.append('points', item["points"]);
                
        /* TODO - response - Text Input */
        if (item['type'] == 'text') {
            formData.append('answer', qiForm.answer);
        }

        console.log("Item Type: " + item['type']);
        if (item['type'] == 'photo') {
            console.log("Append photo.");
            formData.append('fileKey', qiForm.fileToUpload, qiForm.fileToUpload.name);
        }

        this.postQuestItem(formData);
        // ----

        return this.currentScore;
    }

    unCompleteQuestItem(id) {
        var item;

        item = this.getItemById(id);

        item["pts-awarded"] = 0;
        item["complete"] = false;

        this.updateCurrentScore();

        this.saveQuestItems();

        console.log("QuestItemService.unCompleteQuestItem()");
        console.log(item);

        // ----
        const formData: FormData = new FormData();
           
        formData.append('action', 'uncomplete');
        formData.append('questId', id);
        formData.append('teamId', this.loginService.getTeamId().toString());
        formData.append('eventId', this.loginService.getEventId().toString());

        this.postQuestItem(formData);
        // ----

        return this.currentScore;
    }

    getScoreString() {
        return this.currentScore + "/" + this.possibleScore + " PTS";
    }
    

}

export interface QuestItem {
    id: number; 
    title: string; 
    description: string; 
    points: number; 
    "pts-awarded": number; 
    type: string; 
    complete: boolean;
}

export interface QuestItems {
    id: number;
    title: string;
    quests: QuestItem[];
}
